
define('text!modules/strategy/templates/listLayout.html',[],function () { return '<ul class="list strategies">\n\t{{^hasStrategies}}\n\t<li class="no-list-items">\n\t\t<span>{{{noStrategyMessage}}}</span>\n\t</li>\n\t{{/hasStrategies}}\n</ul>';});

